import { getLocalStorage, setLocalStorage } from "@/utils/storage";
const DEVICE_ID_STORAGE_KEY = "autosled.deviceId";
export const DEVICE_ID_HEADER = "X-Device-Id";
let fallbackDeviceId = null;
const generateDeviceId = () => {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};
export const getDeviceId = () => {
    const stored = getLocalStorage(DEVICE_ID_STORAGE_KEY);
    if (typeof stored === "string" && stored) {
        return stored;
    }
    fallbackDeviceId = fallbackDeviceId ?? generateDeviceId();
    setLocalStorage(DEVICE_ID_STORAGE_KEY, fallbackDeviceId);
    return fallbackDeviceId;
};
export const getDeviceHeaders = () => ({
    [DEVICE_ID_HEADER]: getDeviceId(),
});
